module.exports = __webpack_public_path__ + "assets/img/WilliamHill.4bb48010.png";